// extracted by mini-css-extract-plugin
export default {"button":"themetertiary_button__Tn5L6"};